import React from "react";
import { TailSpin } from "react-loader-spinner";
import styles from "./spinner.module.css";

export interface SpinnerProps {
    variant?: 'default' |'inline' | 'overlay'
    label?: string
}

export function Spinner({ variant = 'default', label }: SpinnerProps) {
    return (
        <div className={styles[`variant-${variant}`]} role="status" aria-live="polite" aria-label={label}>
            <TailSpin
                height="80"
                width="80"
                color="var(--primary-color)"
                visible={true}
            />
        </div>
    )
}
